import { render, staticRenderFns } from "./RoomLegend.vue?vue&type=template&id=de27f0c2&scoped=true"
import script from "./RoomLegend.vue?vue&type=script&lang=js"
export * from "./RoomLegend.vue?vue&type=script&lang=js"
import style0 from "./RoomLegend.vue?vue&type=style&index=0&id=de27f0c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de27f0c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VChip,VSheet})
